import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import React from "react";

interface AlertErrorProps {
  errorMessage?: string;
}

const AlertError: React.FC<AlertErrorProps> = ({
  errorMessage = "Something went wrong while loading this section, please try again.",
}: AlertErrorProps) => {
  return (
    <Alert severity="error" variant="outlined">
      <AlertTitle>Error</AlertTitle>
      {errorMessage}
    </Alert>
  );
};

export default AlertError;
